import cn from 'classnames';
import DataTable, { dataTableStyles } from '@creditflowresearch/uilib/Table/DataTable';
import type { IColumn } from '@creditflowresearch/uilib/Table/DataTable/interfaces/Column';
import type { SortOrder } from '@creditflowresearch/uilib/Table/DataTable/interfaces/SortOrder';
import Spinner from '@creditflowresearch/uilib/Loader/Spinner';

import styles from './bondScreenerTable.module.scss';

type TRowKey<T> = string | ((rowData: T, index: number) => string);

interface IBondScreenerTableProps<T> {
  dataTest: string,
  columns: IColumn[],
  data: T[],
  emptyMessage: string,
  isFetching?: boolean,
  sortBy?: string,
  sortOrder?: SortOrder,
  onSortChange?: (sortBy: string, sortOrder: SortOrder) => void,
  rowKey?: TRowKey<T>,
}

export const BondScreenerTable = <T extends { id: string }>({
  dataTest,
  columns,
  data,
  emptyMessage,
  isFetching,
  sortBy,
  sortOrder,
  onSortChange,
  rowKey = 'id',
}: IBondScreenerTableProps<T>) => (
  <DataTable
    dataTest={ dataTest }
    className={ cn(
      dataTableStyles.isHoverable,
      dataTableStyles.nowrapCells,
      styles.clickableRow,
      styles.scrollContainer,
    ) }
    striped
    emptyMessageClassName={ dataTableStyles.emptyMessage }
    columns={ columns }
    data={ data }
    isFetching={ isFetching }
    sortBy={ sortBy }
    sortOrder={ sortOrder }
    onSortChange={ onSortChange }
    loadingComponent={ Spinner }
    emptyMessage={ emptyMessage }
    showEmptyStateMessageFirst
    rowKey={ rowKey }
    dataTestRow={ rowKey }
  />
);
